import { type StepCommand, type CommandId } from './LogCommands';

export type LogRequestMeta = {
  pipelineUuid: string;
  stepUuid: string;
  range?: {
    rangeStart: number;
    rangeEnd: number;
  };
  commandIds?: string[];
  index?: number;
  requestCounter?: number;
  requestType?: LogRequestType;
  stepCommands?: StepCommand[];
};

export type LogV3RequestMeta = {
  pipelineUuid: string;
  stepUuid: string;
  range?: {
    rangeStart: number;
    rangeEnd: number;
  };
  commandIds: CommandId[];
  index: number;
  requestCounter?: number;
  requestType: LogRequestType;
  callback?: () => void;
  repositoryFullSlug?: string;
};

export type StepLogMap = Map<number, string[][]>;

export enum LogRequestType {
  // this is to get the rest of logs for a command when it's not yet fetched but next streaming command already started
  // current streaming request
  STREAMING = 'streaming',
  // clicks on command
  CLICK = 'command click',
  // on load to open commands automatically
  ON_LOAD = 'on load',
  // search or download
  SEARCH_DOWNLOAD = 'search & download',
}

export type LinkifyProps = {
  logLines: string[];
};

export type FlatNestedLogLinesProps = {
  stepLog: StepLogMap;
  logLines: string[];
  meta: LogRequestMeta | LogV3RequestMeta;
};

export type LogLineWorkerProps = LinkifyProps & FlatNestedLogLinesProps;
export type LogLineWorkerReturnTypes =
  | string[]
  | {
      logLines: string[];
      stepLog: StepLogMap;
    };
